import { useState, useEffect } from 'react';

import { useDescribeWebViewSdk, wvSdk } from 'sdk';
import useEventHandler from 'hooks/useEventHandler';
import { useEvent } from 'hooks/socket';
import { Message, Meeting, User } from 'store/models';

interface WebViewConferenceProps {
  meet: Meeting;
  onFinish: () => void;
  onMessage: (e: { text: string }) => any;
}

export default function WebViewConference({
  meet,
  onFinish: exitRoom,
  onMessage: sendMessage,
}: WebViewConferenceProps) {
  const [users, setUsers] = useState<User[]>([]);

  const getRoomInfo: typeof wvSdk['_app']['getRoomInfo'] = useEventHandler(() => {
    return {
      roomUI: true,
      status: meet.finishedAt ? 'ended' : 'in_progress',
    };
  }, [meet.finishedAt]);

  useDescribeWebViewSdk({
    exitRoom,
    sendMessage,
    getRoomInfo,
  });

  useEvent('chat-message', ({ message }: { message: Message }) => {
    wvSdk.gotMessage(message);
  });

  useEvent('conference-info', ({ users, messages }: { users: User[]; messages: Message[] }) => {
    setUsers(users);
    wvSdk.refreshUsersCount(users);
    messages.forEach((message) => {
      wvSdk.gotMessage(message);
    });
  });

  useEvent('conference-enter', ({ user }: { user: User }) => {
    if (!users.some((u) => u._id === user._id)) {
      const newUsers = [...users, user];

      setUsers(newUsers);
      wvSdk.refreshUsersCount(newUsers);
    }
  });

  useEvent('conference-leave', ({ user }: { user: User }) => {
    if (users.some((u) => u._id === user._id)) {
      const newUsers = users.filter((u) => u._id === user._id);

      setUsers(newUsers);
      wvSdk.refreshUsersCount(newUsers);
    }
  });

  useEffect(() => {
    wvSdk.setRoomUi(true);

    return () => {
      wvSdk.setRoomUi(false);
    };
  }, []);

  return null;
}
